import { HttpMethod } from "../types/HttpMethod";

const testDataFeatureApiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/testDataFeature`;

export const getAllTestDataFeatureDTOByClientIdAndUserDetailsId = (
  auth: string,
  clientId: number,
  userDetailsId: number
) => {
  const url = `${testDataFeatureApiUrl}/getAllTestDataFeatureDTOByClientIdAndUserDetailsID/${clientId}/${userDetailsId}`;
  return fetch(url, {
    method: HttpMethod.Get,
    headers: {
      Authorization: auth,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
